import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '../../providers/window.provider';
import { PRODUCT_TYPES } from '../../enums/product-types.enum';
import { constants } from '../../constants/constants';
import { Router } from '@angular/router';
import { FEATURE_FLAGS } from '../../enums/feature-flags.enum';
import { AppConfigService } from '../../app-config/app-config.service';

@Injectable({ providedIn: 'root' })
export class HybridAppService {
	constants = constants;
	constructor(
		@Inject(WINDOW) private readonly window: Window,
		private readonly router: Router
	) {}

	generateHybridAppUrl(route: string): string {
		return `${this.window.location.origin}/#/${route}`;
	}

	navigateToBaseLogin(params?: { [key: string]: string }): void {
		this.navigateToUrl('login', params);
	}

	navigateToUrl(route: string, params?: { [key: string]: string }): void {
		let url = `${this.window.location.protocol}//${this.window.location.host}/#/${route}`;

		if (params) {
			const queryParams = new URLSearchParams(params).toString();
			url += `?${queryParams}`;
		}

		this.window.location.href = url;
	}

	navigateToWebUrl(url: string): void {
		const route = url.split('#').pop();
		this.window.location.href = `${this.window.location.protocol}//${this.window.location.host}/#${route}`;
	}

	navigateToProperNewApplicationFlowByProduct(
		activeProduct: number,
		participantId: number
	): void {
		let loc = '';
		switch (activeProduct) {
			case PRODUCT_TYPES.tuition:
				loc = `${this.constants.BASE_APP_ROUTES.FAST_TRACK_BASE}${this.constants.BASE_APP_ROUTES.PROGRAMS_STEP}${participantId}`;
				break;
			default:
				loc = `${this.constants.BASE_APP_ROUTES.FAST_TRACK_BASE}${this.constants.BASE_APP_ROUTES.PROGRAMS_STEP}${participantId}`;
				break;
		}

		this.window.location.href = this.generateHybridAppUrl(loc);
	}

	navigateToScheduleAppointmentPage(): void {
		this.router.navigate([constants.routes.TUITION.ADVISING_APPOINTMENT]);
	}
	navigateToCoachingResourcesPage(): void {
		this.router.navigate([constants.routes.advising]);
	}

	navigateToClientCustomPathwayPage(): void {
		this.router.navigate([constants.routes.CLIENT_CUSTOM_PATHWAY]);
	}
}
